import styled from '@emotion/styled';
import { AppBar, IconButton, Menu, MenuItem, Tab, Tabs, Toolbar } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import AccountCircle from '@material-ui/icons/AccountCircle';
import HelpIcon from '@material-ui/icons/Help';
import MenuIcon from '@material-ui/icons/Menu';
import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import logo from '../../assets/axcess logo_primary.svg';
import { Box } from '../UI';
import FloatingMenu from './FloatingMenu';

const Header = ({ match }) => {
	const classes = useStyles();
	const basePath = `/${match.path.split('/')[1]}`;
	const [anchorNav, setAnchorNav] = React.useState(null);
	const [anchorEl, setAnchorEl] = React.useState(null);
	const [isFloatingMenuOpen, setFloatingMenuOpen] = React.useState(false);
	const isMenuOpen = Boolean(anchorEl);
	const isNavOpen = Boolean(anchorNav);

	const handleProfileMenuOpen = event => {
		setAnchorEl(event.currentTarget);
	};
	const handleMenuClose = () => {
		setAnchorEl(null);
	};

	const handleNavMenuOpen = event => {
		setAnchorNav(event.currentTarget);
	};
	const handleNavClose = () => {
		setAnchorNav(null);
	};

	const menuId = 'primary-search-account-menu';
	const renderMenu = (
		<Menu
			anchorEl={anchorEl}
			anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
			id={menuId}
			keepMounted
			transformOrigin={{ vertical: 'top', horizontal: 'right' }}
			open={isMenuOpen}
			onClose={handleMenuClose}
		>
			<MenuItem onClick={handleMenuClose}>My Account</MenuItem>
			<MenuItem onClick={handleMenuClose}>
				<Link to="/" style={{ color: 'inherit', textDecoration: 'none' }}>
					Logout
				</Link>
			</MenuItem>
		</Menu>
	);

	const navId = 'nav-dropdown';
	const renderNav = (
		<Menu
			anchorEl={anchorNav}
			anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
			id={navId}
			keepMounted
			transformOrigin={{ vertical: 'top', horizontal: 'right' }}
			open={isNavOpen}
			onClose={handleNavClose}
		>
			<MenuItem onClick={handleMenuClose}>
				<Link to="/my-portfolio" style={{ color: 'inherit', textDecoration: 'none' }}>
					My Portfolio
				</Link>
			</MenuItem>
			<MenuItem onClick={handleMenuClose}>
				<Link to="/market-search" style={{ color: 'inherit', textDecoration: 'none' }}>
					Market Search
				</Link>
			</MenuItem>
			<MenuItem onClick={handleMenuClose}>
				<Link to="/my-processes" style={{ color: 'inherit', textDecoration: 'none' }}>
					My Processes
				</Link>
			</MenuItem>
		</Menu>
	);
	return (
		<>
			<AppBar position="static" className={classes.nav} color="default">
				<Toolbar>
					<Box>
						<Link
							to="/"
							style={{
								color: 'inherit',
								textDecoration: 'none',
								display: 'flex',
								alignItems: 'center',
							}}
						>
							<img src={logo} alt="aXcess logo" className={classes.logo} />
						</Link>
					</Box>

					<Box display="flex" flexGrow="1" justifyContent="center">
						<Tabs>
							<NavTab
								label="My Portfolio"
								component={Link}
								to="/my-portfolio"
								active={basePath === '/my-portfolio'}
							/>
							<NavTab
								label="Market Search"
								component={Link}
								to="/market-search"
								active={basePath === '/market-search'}
							/>
							<NavTab
								label="My Processes"
								component={Link}
								to="/my-processes"
								active={basePath === '/my-processes'}
							/>
						</Tabs>
					</Box>
					<Box display={['block', 'block', 'none', 'none']}>
						<Tooltip title="Navigation" aria-label="nav">
							<IconButton
								edge="end"
								color="inherit"
								aria-label="nav"
								aria-controls={navId}
								aria-haspopup="true"
								onClick={handleNavMenuOpen}
								className={classes.icon}
							>
								<MenuIcon />
							</IconButton>
						</Tooltip>
					</Box>

					<Box display="flex" width="96px">
						<Tooltip title="Saul Hudson" aria-label="account">
							<IconButton
								edge="end"
								color="inherit"
								aria-label="menu"
								aria-controls={menuId}
								aria-haspopup="true"
								onClick={handleProfileMenuOpen}
								className={classes.icon}
							>
								<AccountCircle />
							</IconButton>
						</Tooltip>
						<Tooltip title="Support" aria-label="support">
							<IconButton color="inherit" aria-label="menu">
								<HelpIcon />
							</IconButton>
						</Tooltip>
					</Box>
				</Toolbar>
				{renderMenu}
				{renderNav}
			</AppBar>
			{!!match.path && match.path.includes('my-portfolio') && (
				<FloatingMenu isOpen={isFloatingMenuOpen} setOpen={setFloatingMenuOpen} />
			)}
		</>
	);
};

const useStyles = makeStyles(theme => ({
	nav: {
		position: 'relative',
		padding: 0,
	},
	navLink: {
		marginRight: theme.spacing(4),
	},
	icon: {
		display: 'flex',
		flexDirection: 'column',
	},
	logo: {
		height: '24px',
	},
}));

const NavTab = styled(Tab)`
	color: #202020 !important;
	opacity: 100%;
	height: 100%;
	padding-right: 0;
	padding-left: 0;
	${({ active }) => (active ? 'border-bottom: 2px solid #b60037' : 'border-bottom: none;')};
`;

export default withRouter(Header);
